export const CART_ELEMENT_IDS = {
    CART_RENDERER_CONTAINER_SELECTOR: "#cart-renderer-container",
    CART_RENDERER_CONTAINER_ID: "cart-renderer-container",
    DE_TIP_CONTAINER: "#de-tip-container",
    DELIVERY_INSTRUCTIONS_CONTAINER_SELECTOR: "#delivery-instructions-container",
    BILL_DETAILS_CONTAINER: "#bill-details-container",
};
export const SCROLL_MARGIN_TOP_WITH_SAVING_BANNER = 150;
export const SCROLL_MARGIN_TOP_WITHOUT_BANNER = 80;
export const SCROLL_MARGIN_TOP_WITH_OFO_BANNER = 240;

export const WRITE_INSTRUCTIONS_FOR_REST = "Write instructions for restaurant";
